<template>
  <div class="text-wrapper">
    <!-- 搜索项 -->
    <div class="search-wrapper flex">
      <div class="input-wrapper flex">
        <p>机构名称：</p>
        <el-input v-model="tableInfo.query.name" placeholder="请输入机构名称" />
      </div>
      <div class="input-wrapper flex">
        <p>状态：</p>
        <el-select v-model="tableInfo.query.status" clearable placeholder="请选择状态">
          <el-option label="全部" value="" />
          <el-option label="已启用" :value="1" />
          <el-option label="已停用" :value="2" />
        </el-select>
      </div>
      <div class="btn-wrapper">
        <el-button type="primary" @click="getList">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </div>
    </div>

    <div class="table">
      <el-row type="flex">
        <el-button type="primary" icon="el-icon-s-tools" @click="showFiled">
          字段管理
        </el-button>
        <el-button type="primary" icon="el-icon-s-tools" @click="showWord">
          屏蔽词管理
        </el-button>
        <el-button type="primary" style="margin-left: auto" @click="handleExport">
          导出
        </el-button>
      </el-row>
      <!-- <el-button class="add" type="primary" @click="add">新建</el-button> -->
      <cooperator-table
        :listen-height="false"
        :refresh="tableInfo.refresh"
        :data.sync="tableInfo.data"
        :query="tableInfo.query"
        :pager="true"
        :api="organizationList"
        :field-list="tableInfo.fieldList"
        :handle="tableInfo.handle"
        @handleClick="handleClick"
        @handleEvent="handleEvent"
        ref="publicRef"
      >
        <template v-slot:col-status="scope">
          <p>{{ scope.row.status === 2 ? '已停用' : '已启用' }}</p>
        </template>
        <!-- 自定义插槽状态按钮 -->
        <template v-slot:bt-status="scope">
          <el-button
            :type="'text'"
            :loading="scope.data.row[scope.data.item.loading]"
            @click="handleClick(scope.data.item.event, scope.data.row)"
          >
            {{ scope.data.row.status === 1 ? '停用' : '启用' }}
          </el-button>
        </template>
        <!-- 自定义插槽状态按钮 -->
        <template v-slot:bt-delete="scope">
          <el-button
            v-if="scope.data.row.status === 2"
            :type="'text'"
            :loading="scope.data.row[scope.data.item.loading]"
            @click="handleClick(scope.data.item.event, scope.data.row)"
          >
            {{ scope.data.item.label }}
          </el-button>
        </template>
      </cooperator-table>
    </div>
    <!-- 字段管理 -->
    <field-dialog
      ref="fieldDialog"
      :field-visible="fieldVisible"
      @close="fieldVisible = false"
      @refresh="getList"
    >
    </field-dialog>
    <!-- 机构新增 -->
    <organization-dialog
      ref="organizationDialog"
      :dialog-visible="dialogVisible"
      @close="dialogVisible = false"
      @submit="onSubmit"
    >
    </organization-dialog>
    <!-- 屏蔽词管理 -->
    <BlockWord ref="wordRef" />
    <FileExport ref="FileExport" />
  </div>
</template>
<script>
import CooperatorTable from '@/components/PublicTable'
import FieldDialog from './components/fieldDialog'
import OrganizationDialog from './components/organizationDialog'
import BlockWord from './components/blockWord.vue'
import FileExport from '@/components/FileExport.vue'

import {
  organizationList,
  delOrganization,
  addOrganization,
  organizationState,
  getFieldList,
  updateOrganization,
  getField
} from '@/api/api'
export default {
  components: {
    CooperatorTable,
    FieldDialog,
    OrganizationDialog,
    BlockWord,
    FileExport
  },
  data() {
    return {
      organizationList,
      dialogVisible: false,
      fieldVisible: false,
      fieldList: [],
      tableInfo: {
        refresh: 1,
        initTable: false,
        data: [],
        query: {
          name: '',
          status: ''
        },
        fieldList: [
          { label: '排序号', value: 'sortNum' },
          // { label: '机构编码', value: 'id' },
          { label: '机构名称', value: 'name' },
          { label: '营业执照号', value: 'licenseNum' },
          { label: '所属教务服务方', value: 'parentCompanyName' },
          { label: '状态', value: 'status', type: 'slot' }
        ],
        handle: {
          label: '操作',
          btList: [
            {
              label: '启用',
              type: 'text',
              event: 'status',
              show: true,
              slot: true
            },
            // {
            //   label: '删除',
            //   type: 'text',
            //   event: 'delete',
            //   show: true,
            //   slot: true
            // },
            { label: '编辑', type: 'text', event: 'edit', show: true }
          ]
        }
      },
      field: []
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getList()
    })
  },
  methods: {
    getShowField() {
      getField().then(res => {
        let { code, data } = res;
        if (code === 0) {
          this.field = data;
        }
      })
    },
    add() {
      this.dialogVisible = true
      this.$refs.organizationDialog.init({
        fieldList: this.field
      })
    },
    showFiled() {
      this.fieldVisible = true
    },
    // 提交表单
    onSubmit(form) {
      if (form.id) {
        updateOrganization(form).then((res) => {
          let { code, message } = res
          if (code === 0) {
            this.dialogVisible = false
            this.getList()
            this.$message.success('保存成功')
          } else {
            this.$message.error(message)
          }
        })
      } else {
        addOrganization(form).then((res) => {
          let { code, message } = res
          if (code === 0) {
            this.dialogVisible = false
            this.getList()
            this.$message.success('保存成功')
          } else {
            this.$message.error(message)
          }
        })
      }
    },
    // 通过随机数请求列表
    getList() {
      this.tableInfo.refresh = Math.random()
      this.getShowField();
      getFieldList({
        page: 1,
        limit: 20
      }).then((res) => {
        let { code, message, data } = res
        if (code === 0) {
          this.fieldList = data.records
          this.$refs.fieldDialog.init(data)
        } else {
          this.$message.error(message)
        }
      })
    },
    // 重置
    reset() {
      this.tableInfo.query.name = ''
      this.tableInfo.query.status = ''
      this.getList();
    },
    // table操作
    handleClick(event, row) {
      if (event === 'status') {
        organizationState({
          id: row.id,
          status: row.status === 1 ? 2 : 1
        }).then((res) => {
          let { code, message } = res
          if (code === 0) {
            this.$message.success(row.status === 1 ? '停用成功' : '启用成功')
            this.getList()
          } else {
            this.$message.error(message)
          }
        })
      } else if (event === 'delete') {
        this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delOrganization({
            id: row.id
          }).then((res) => {
            let { code, message } = res
            if (code === 0) {
              this.$message.success('删除成功')
              this.getList()
            } else {
              this.$message.error(message)
            }
          })
        })
      } else {
        this.dialogVisible = true
        this.$refs.organizationDialog.init({
          fieldList: this.field,
          form: row
        })
      }
    },
    // table数据
    handleEvent(data) {
      const { page, limit } = this.$refs.publicRef?.listInfo?.query
      this.tableInfo.data = data.records.map((item, index) => ({
        ...item,
        sortNum: (page - 1) * limit + index + 1
      }))
    },
    showWord() {
      this.$refs.wordRef.handleOpen()
    },
    handleExport() {
      const { name, status } = this.tableInfo.query
      const params = { name, status }
      this.$refs.FileExport.init(
        params,
        'jsw-radioweb-provider', // 后端对应业务线服务
        '/adm/organization/exportData', // 导出-对应的接口
        1,
        '机构列表.xlsx' //文件名称
      )
    }
  }
}
</script>
<style lang="scss" scoped>
.text-wrapper {
  padding: 16px;
  background-color: #fff;
  border-radius: 4px;
  .flex {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .search-wrapper {
    width: 100%;
    .input-wrapper {
      .el-input {
        width: 200px;
        margin-left: 10px;
      }
      & + .input-wrapper {
        margin-left: 16px;
      }
    }
    .btn-wrapper {
      margin-left: 30px;
    }
  }

  .set {
    display: block;
  }
  .add {
    margin-left: 0;
    display: block;
  }

  .table {
    margin-top: 20px;
    .el-button {
      margin-bottom: 10px;
    }
  }
}
</style>
